<template>
    <div >
        <v-sheet   v-intersect="{
            handler: onIntersect,
            options: {
              threshold: [0.2]
            }
          }" v-if="!isIntersecting" class="mx-auto" style="background-size:cover;cursor:pointer;position:relative;" height="320" width="204" dark>
            <v-skeleton-loader
                    light

                    class="mx-auto"
                    type="image"
                    style="z-index:1;position:absolute;width: 165px; top: 32px; left: 20px; height: 120px;"
            ></v-skeleton-loader>

        </v-sheet>

        <v-slide-x-transition>
            <v-card
                    v-if="isIntersecting"
                flat
                max-width="204"
                style="background:transparent;"
                @click="clicked"
                class="mx-auto"
                min-width="204"
        >


            <v-card-text @mouseleave="unlift" @mouseover="lift"  class="pb-0 pa-0">
                <img @load="total_load+=1"  class="plastic_cover" v-if="plastic_1 && this.$vuetify.breakpoint.mdAndUp" style="position:absolute;z-index: 1;width:240px;opacity:0.3;top: 40px; left: -15px;height:250px;" :src="require('../assets/6.png')"/>
                <img @load="total_load+=1"  class="plastic_cover" v-if="!plastic_1 && this.$vuetify.breakpoint.mdAndUp" style="position:absolute;z-index: 1;width:240px;opacity:0.3;top: 40px; left: -15px;height:250px;" :src="require('../assets/2.png')"/>
                <v-card :class="animation" elevation="20" dark raised  :style="{ backgroundImage: `url('${background_image}')`}" style="background-size:cover;cursor:pointer;" height="284" width="204">
                    <img :src="streamer_image" @load="total_load+=1"   style="z-index: 1; position: absolute; width: 154px; top: 34px; left: 25px; height: 110px;"/>

                    <img :src="decorator_image" @load="total_load+=1" style="z-index:2;height:100%;width:100%;background-size:cover;position: absolute;"/>
                    <v-textarea
                            dark
                            style="position: absolute; bottom: 28px; width: 180px; left: 10px; height: 80px;overflow:hidden;"
                            class="ac_textarea"
                            solo
                            v-model="this.data.TEXT"
                            label=""
                            no-resize
                            readonly
                            height="80"
                    ></v-textarea>

                </v-card>

            </v-card-text>
            <v-card-actions  style="position:relative;z-index: 0;" :style="{'top':$vuetify.breakpoint.mdAndUp? '-50px':'10px'}" class="pa-0 mt-0">
                <v-avatar size="35" style="position:absolute;z-index: 1;">
                    <v-img

                            :src="streamer_avatar"
                    ></v-img>
                </v-avatar>
                <v-btn
                        :color=rank_color
                        tile
                        depressed


                        class="mx-auto"
                >
                    <b>{{data.NAME}}</b>
                    <v-icon v-if="data.VIDEO.video_id && data.VIDEO.opacity>10 ">mdi-video</v-icon>
                    <v-icon v-else-if="data.VIDEO.video_id && data.VIDEO.volume>10 ">mdi-music-note</v-icon>
                </v-btn>




            </v-card-actions>
        </v-card>
        </v-slide-x-transition>
    </div>

</template>

<script>
    export default {
        name: "ActionCard",
        data(){
            return{
                total_load:0,
                animation:"",
                isAnimating:false,
                isActive:false,
                isIntersecting:false



            }
        },
        props: {
            "data":Object,
            "editable":Boolean,
            "list_index":Number

        },


        computed:{
            loading:function(){
              return this.total_load<2;
            },

            plastic_1:function(){
                return Math.random() >= 0.5;


            },
            background_image:function(){

                return `/api/images/cards/activity/bg.png`
            },
            decorator_image:function(){
                return `/api/images/cards/activity/${this.data.RANK}.png`
            },
            streamer_image:function(){

                let random=(parseInt(Math.random()*1000)).toString();
                return  `/api/images/cards/streamer_images/${this.data["STID"]}/${this.data.RANK}.png?random=${random}`



            },
            streamer_avatar:function(){
                return  `/api/images/cards/streamer_images/${this.data["STID"]}/avatar.png`

            },
            rank_color:function(){
                if(this.data.RANK===0){
                    return "green"
                }
                else if(this.data.RANK===1){
                    return "blue"
                }
                else if(this.data.RANK===2){
                    return "purple"
                }
                else if(this.data.RANK===3){
                    return "orange"
                }
                else{
                    return "black"
                }
            },
            rank_text:function(){
                if(this.data.RANK===0){
                    return "Vanlig"
                }
                else if(this.data.RANK===1){
                    return "Ovanlig"
                }
                else if(this.data.RANK===2){
                    return "Epic"
                }
                else if(this.data.RANK===3){
                    return "Legendary"
                }
                else{
                    return "Okänd"
                }
            }
        },

        methods:{
            onIntersect:function(entries){
                this.isIntersecting=entries[0].isIntersecting;

            },
            unlift:function(){
                if(!this.isAnimating){
                    this.animation="unlift";
                }
                else{
                    let self=this;
                    setTimeout(function(){
                        self.animation="unlift";
                    },300)
                }
            },
            lift:function(){
                this.animation="lift";
                this.isAnimating=true;
                let self=this;
                setTimeout(function(){
                    self.isAnimating=false;
                },300)
            },
            clicked:function(){
                this.$emit('clicked',this.data,this.list_index)




            },
            onImgLoad(){
                this.loading=false
            }

        }
    }
</script>

<style scoped>
    .unlift {
        transform: translateY(0);
        transition: transform .2s;
    }
    .lift {
        transform: translateY(-80px) rotate(2deg);
        transition: transform .2s;
    }

</style>
